import UserLayout from "../../../layouts/user";
import ResentCourse from "./_components/ResentCourse";
import TopBar from "./_components/TopBar";

const breadcrumb = [
  {
    title: "হোম",
    path: "/",
  },
  {
    title: "ড্যাশবোর্ড",
  },
];

export default function UserDashboard() {
  return (
    <UserLayout title="ড্যাশবোর্ড" breadcrumb={breadcrumb}>
      <TopBar />
      <ResentCourse />
      {/* <Certificates /> */}
    </UserLayout>
  );
}
